import { render, staticRenderFns } from "./SpotifySettingSection.vue?vue&type=template&id=0b713b05&"
import script from "./SpotifySettingSection.vue?vue&type=script&lang=js&"
export * from "./SpotifySettingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports